/**
 * Who signs the printed prescription and lab report (medopd-docs 100): the doctor's own qualifications,
 * registration number and signature; the clinic's lab signatory, NABL number and lab hours.
 */
import { fetchApi, fetchMultipartApi, API_BASE_URL } from '../client';

export interface PrescriberProfile {
  name: string | null;
  specialization: string | null;
  qualifications: string | null;
  registrationNumber: string | null;
  hasSignature: boolean;
}

export interface LabReportSettings {
  signatoryName: string | null;
  signatoryTitle: string | null;
  signatoryQualification: string | null;
  nablNumber: string | null;
  workingHours: string | null;
  hasSignature: boolean;
}

const file = (f: File) => {
  const fd = new FormData();
  fd.append('file', f);
  return fd;
};

export const reportLetterheadModule = {
  prescriber: () => fetchApi<PrescriberProfile>('/api/users/me/prescriber-profile'),
  savePrescriber: (body: { qualifications: string; registrationNumber: string }) =>
    fetchApi<PrescriberProfile>('/api/users/me/prescriber-profile', { method: 'PUT', body: JSON.stringify(body) }),
  uploadMySignature: (f: File) => fetchMultipartApi<PrescriberProfile>('/api/users/me/signature', file(f)),
  deleteMySignature: () => fetchApi<PrescriberProfile>('/api/users/me/signature', { method: 'DELETE' }),
  /** Served only to its owner; the version busts the browser cache after an upload. */
  mySignatureSrc: (version: number) => `${API_BASE_URL}/api/users/me/signature?v=${version}`,

  labSettings: (clinicId: string) => fetchApi<LabReportSettings>(`/api/clinics/${clinicId}/lab-report-settings`),
  saveLabSettings: (clinicId: string, body: Omit<LabReportSettings, 'hasSignature'>) =>
    fetchApi<LabReportSettings>(`/api/clinics/${clinicId}/lab-report-settings`, { method: 'PUT', body: JSON.stringify(body) }),
  uploadLabSignature: (clinicId: string, f: File) =>
    fetchMultipartApi<LabReportSettings>(`/api/clinics/${clinicId}/lab-signature`, file(f)),
  deleteLabSignature: (clinicId: string) =>
    fetchApi<LabReportSettings>(`/api/clinics/${clinicId}/lab-signature`, { method: 'DELETE' }),
  labSignatureSrc: (clinicId: string, version: number) => `${API_BASE_URL}/api/clinics/${clinicId}/lab-signature?v=${version}`,
};
